/* batida-cart-split.js (3.10, Aleksandra): one Shopify shop, two kinds of cart.
   - b2b.batida.pl: only B2B products (tag "b2b") and no discount codes (LOY-, REF-, WITAJ10 are batida.pl codes; companies
     get their price through automatic discounts). Codes found on the cart are taken off quietly.
   - batida.pl: no B2B products.
   11.10 (Aleksandra, #136): "two independent carts". Guests already have one cart per address (host-only cookie); a
   customer logged in to Moje konto shares one cart on both addresses. A line of the other kind is no longer shown in a
   bar with a "remove" button: it is set aside quietly (taken off the cart and kept in the cart attribute _park_b2c /
   _park_b2b, with its quantity, properties and selling plan) and put back unchanged on the next visit of its own
   address. No window, nothing deleted. Any way to the checkout (cart form "checkout", the drawer, the new cart's pay
   button, a /checkout link) still waits for a fresh check of the cart (which sets aside what does not belong). Which line is which comes from /cart?view=split (templates/cart.split.liquid), so it is always
   the server's answer. Texts: locale batida.cart_split (snippets/batida-cart-split.liquid). */
(function () {
  'use strict';
  var cfgEl = document.querySelector('[data-cart-split-cfg]');
  if (!cfgEl) return;
  var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.t || {}, B2B = !!C.b2b;
  var MINE = B2B ? 'b2b' : 'b2c', OTHER = B2B ? 'b2c' : 'b2b', running = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var state = null, bar = null, busy = false;

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* 4.10 (Astra S-01/S-02): every failure blocks the way to the checkout. A failed, slow (8 s) or malformed answer is an
     error, never an "empty, clean cart"; a failed code removal or line removal is an error too, and success is only
     believed after a fresh check. On an error the bar says the cart could not be checked and offers "Spróbuj ponownie". */
  /* one attempt: 8 s for the answer AND its body; resolves with the response text, rejects on network error, timeout or non-2xx */
  function timed(url, opts) {
    var ctl = window.AbortController ? new AbortController() : null, tm = 0;
    if (ctl) opts.signal = ctl.signal;
    return new Promise(function (resolve, reject) {
      tm = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (e) {} reject(new Error('timeout')); }, 8000);
      fetch(root + url, opts).then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      }).then(resolve, reject);
    }).then(function (t) { clearTimeout(tm); return t; }, function (e) { clearTimeout(tm); throw e; });
  }
  function parseView(t) {
    var j = JSON.parse(t);
    if (!j || !Array.isArray(j.items) || !Array.isArray(j.codes)) throw new Error('bad split view');
    return j;
  }
  /* reading the cart is safe to repeat: one automatic retry after any failure (network, timeout, non-2xx, bad JSON) */
  function load() {
    /* no "Accept: application/json" here: with it Shopify answers with the plain cart JSON instead of this view */
    var once = function () { return timed('cart?view=split', { credentials: 'same-origin' }).then(parseView); };
    return once().catch(function () { return new Promise(function (r) { setTimeout(r, 400); }).then(once); });
  }
  function foreign(s) { return (s.items || []).filter(function (i) { return B2B ? !i.b2b : i.b2b; }); }
  function post(url, body) {
    return timed(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (t) { return JSON.parse(t); });
  }
  function changed() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true })); } catch (e) {}
      return cart;
    }).catch(function () {});
  }
  /* b2b: discount codes off (the cart and the remembered checkout code); resolves only when a fresh check shows none */
  function clearCodes(s) {
    if (!B2B) return Promise.resolve(s);
    try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
    if (!(s.codes || []).length) return Promise.resolve(s);
    return post('cart/update.js', { discount: '' }).then(load).then(function (fresh) {
      if ((fresh.codes || []).length) throw new Error('codes still on the cart');
      return fresh;
    });
  }

  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div'); bar.className = 'cart-split'; bar.setAttribute('role', 'alert');
    var st = document.createElement('style');
    st.textContent = '.cart-split{position:fixed;left:16px;right:16px;bottom:16px;z-index:9998;max-width:640px;margin:0 auto;background:#1D1414;color:#fff;border-radius:16px;padding:16px 18px;box-shadow:0 14px 40px rgba(0,0,0,.25);font:500 14px/1.45 system-ui,-apple-system,"Outfit",sans-serif}' +
      '.cart-split[hidden]{display:none}.cart-split b{display:block;font-size:15px;margin-bottom:4px}.cart-split p{margin:0 0 12px;color:rgba(255,255,255,.85)}' +
      '.cart-split button{border:0;border-radius:999px;background:#fff;color:#1D1414;font:600 14px/1 inherit;padding:12px 18px;cursor:pointer}.cart-split button[disabled]{opacity:.6;cursor:default}';
    document.head.appendChild(st);
    document.body.appendChild(bar);
    bar.addEventListener('click', function (e) {
      var rb = e.target.closest && e.target.closest('[data-cart-split-retry]');
      if (rb) { rb.disabled = true; check().catch(showError); }
    });
    return bar;
  }
  function showError() {
    ensureBar();
    bar.innerHTML = '<b>' + esc(T.err || 'Nie udało się sprawdzić koszyka. Spróbuj jeszcze raz.') + '</b>' +
      '<button type="button" data-cart-split-retry>' + esc(T.retry || 'Spróbuj ponownie') + '</button>';
    bar.hidden = false;
  }
  /* ---------- 11.10 (#136): set aside / put back ---------- */
  /* Liquid prints cart attributes HTML-escaped (&quot; ...): undo that before reading the list */
  function unesc(v) { return String(v || '').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'); }
  function parked(s, kind) { try { var a = JSON.parse(unesc(s.park && s.park[kind]) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  /* the cart view prints a line's properties as [[name, value], ...]; the cart API takes {name: value} */
  function propsObj(p) { var o = {}; if (Array.isArray(p)) p.forEach(function (kv) { if (kv && kv[0] != null && kv[1] != null && kv[1] !== '') o[kv[0]] = kv[1]; }); else if (p && typeof p === 'object') Object.keys(p).forEach(function (k) { if (p[k] != null && p[k] !== '') o[k] = p[k]; }); return o; }
  function entry(i) { var e = { id: i.id, q: i.qty }, p = propsObj(i.props); if (Object.keys(p).length) e.p = p; if (i.sp) e.s = i.sp; return e; }
  function addItem(e) { var o = { id: e.id, quantity: e.q }; if (e.p) o.properties = e.p; if (e.s) o.selling_plan = e.s; return o; }
  function same(a, b) { return a.id === b.id && JSON.stringify(a.p || {}) === JSON.stringify(b.p || {}) && (a.s || 0) === (b.s || 0); }
  var touched = false;   // something was set aside or put back on this page: the cart page re-renders from the server
  /* this address's own lines that were set aside on the other address come back (all at once; if one can no longer be
     bought, e.g. sold out, the others one by one). The list is cleared first, so a slow page never adds them twice. */
  function restore(s) {
    var mine = parked(s, MINE); if (!mine.length) return Promise.resolve(s);
    var attrs = {}; attrs['_park_' + MINE] = '';
    var items = mine.map(addItem);
    return post('cart/update.js', { attributes: attrs }).then(function () {
      return post('cart/add.js', { items: items }).catch(function () {
        return items.reduce(function (pr, it) { return pr.then(function () { return post('cart/add.js', { items: [it] }).catch(function () {}); }); }, Promise.resolve());
      });
    }).then(function () { touched = true; return load(); });
  }
  /* lines of the other kind go into the other address's list (merged with what is already there) and off this cart, in one update */
  function park(s) {
    var f = foreign(s); if (!f.length) return Promise.resolve(s);
    var list = parked(s, OTHER);
    f.forEach(function (i) { var e = entry(i), hit = null; list.forEach(function (x) { if (!hit && same(x, e)) hit = x; }); if (hit) hit.q += e.q; else list.push(e); });
    var upd = {}; f.forEach(function (i) { upd[i.key] = 0; });
    var attrs = {}; attrs['_park_' + OTHER] = JSON.stringify(list);
    return post('cart/update.js', { updates: upd, attributes: attrs }).then(load).then(function (fresh) {
      if (foreign(fresh).length) throw new Error('lines still in the cart');
      touched = true; return fresh;
    });
  }
  function render() { if (bar) bar.hidden = true; }
  function check() {
    if (running) return running;
    busy = true; touched = false;
    running = load().then(restore).then(clearCodes).then(park).then(function (s) {
      state = s; render();
      if (!touched) return s;
      // the cart page draws its lines on the server: reload it once; elsewhere the header / drawer hear the change
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return new Promise(function () {}); }
      // the header count / drawer may still hold the read made when the page loaded: refresh them again a moment later
      setTimeout(function () { try { if (window.__batidaRefreshCart) window.__batidaRefreshCart(); } catch (e) {} changed(); }, 1200);
      return changed().then(function () { return s; });
    });
    var done = function () { running = null; setTimeout(function () { busy = false; }, 120); };
    running.then(done, done);
    return running;
  }

  /* the way to the checkout waits for a clean cart; any error keeps it closed */
  function isCheckoutForm(f, sub) { return f && f.tagName === 'FORM' && ((sub && sub.name === 'checkout') || /\/checkout/.test(f.getAttribute('action') || '')); }
  function isCheckoutClick(el) {
    if (!el) return null;
    var a = el.closest('a[href*="/checkout"], [data-pay], button[name="checkout"], .checkout__button');
    return a;
  }
  document.addEventListener('click', function (e) {
    var el = isCheckoutClick(e.target); if (!el) return;
    if (el.__splitOk) { el.__splitOk = false; return; }
    if (el.tagName === 'BUTTON' && el.type === 'submit' && el.form) return;   /* handled by the submit listener */
    e.preventDefault(); e.stopImmediatePropagation();
    check().then(function (s) {
      if (foreign(s).length) return;
      el.__splitOk = true; el.click();
    }).catch(showError);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, sub = e.submitter;
    if (!isCheckoutForm(f, sub)) return;
    if (f.__splitOk) { f.__splitOk = false; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    check().then(function (s) {
      if (foreign(s).length) return;
      f.__splitOk = true;
      if (f.requestSubmit) f.requestSubmit(sub && sub.form === f ? sub : undefined); else f.submit();
    }).catch(showError);
  }, true);

  /* check now when the cart has something, and again after every cart change */
  if (C.count > 0 || C.parked) check().catch(showError);
  else if (B2B) { try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {} }
  document.addEventListener('theme:cart:change', function () { if (!busy) setTimeout(function () { check().catch(showError); }, 50); });
})();
